import { post, get } from './helper'
// import './mock'

const login = post(process.env.VUE_APP_BASE_API_BIZ + '/api/platform/auth/login')
const getReportList = post(process.env.VUE_APP_BASE_API_BIZ + '/api/biz/account/getSummary')
const getSelectType = get(process.env.VUE_APP_BASE_API_BIZ + '/api/biz/account/getEnum')
const downloadExcel = post(process.env.VUE_APP_BASE_API_BIZ + '/api/biz/file/downloadSummary',{
  load: true
})
export {
  login,
  getReportList,
  getSelectType,
  downloadExcel
}
